<template>
  <div class="container">
    <div class="row">
      <div class="col-12 page-header">
        <h1>Roster</h1>
        <p>View historic NFL team rosters. Click on a player name to view their stats.</p>
      </div>
    </div>
    <v-roster-input :cacheKey="cacheKey" @update="updateData" />
    <v-roster-results class="mt-5" />
  </div>
</template>

<script>
import { pageRoster } from '~/enums/cacheKeys';

export default {
  name: 'Roster',

  computed: {
    cacheKey: () => { return pageRoster; },
  },

  methods: {
    async updateData() {
      this.$store.dispatch('cache/queryApi', this.cacheKey);
    },
  },

  metaInfo: {
    meta: [
      { name: 'description', content: 'View historic NFL team rosters. Click on a player name to view their stats.' },
    ],
  },
};
</script>

<style lang="scss">

</style>
